import {DashboardFilterSelectOption} from "./dashboard_filter_select_option";

export interface ParentFilterSettingsInterface {
  parentFilterName: string;
  showAllOptionsWhenParentFilterValueIsNull?: boolean;
}

export abstract class ParentFilterSettings<O, PFV> {
  readonly parentFilterName: string;
  readonly showAllOptionsWhenParentFilterValueIsNull: boolean;

  protected constructor(args: ParentFilterSettingsInterface) {
    this.parentFilterName = args.parentFilterName;
    this.showAllOptionsWhenParentFilterValueIsNull = args.showAllOptionsWhenParentFilterValueIsNull ?? false;
  }

  getFilteredChildOptions(parentFilterValue: PFV, options: O[]): O[] {
    if (((parentFilterValue === null || parentFilterValue === '-1') && this.showAllOptionsWhenParentFilterValueIsNull)) {
      return options
    }
    if (parentFilterValue === null) {
      return [];
    }
    return this._getFilteredChildOptions(parentFilterValue, options);
  }

  abstract _getFilteredChildOptions(parentFilterValue: PFV, options: O[]): O[];
}


export class SingleSelectParentSelectChildFilterSettings extends ParentFilterSettings<DashboardFilterSelectOption, string> {
  filterByKey: string;

  constructor(args: ParentFilterSettingsInterface & { filterByKey: string }) {
    super(args);
    this.filterByKey = args.filterByKey;
  }

  _getFilteredChildOptions(parentFilterValue: string, options: DashboardFilterSelectOption[]): DashboardFilterSelectOption[] {
    return options.filter(option => option[this.filterByKey] === parentFilterValue);
  }
}

export class MultiSelectParentSelectChildFilterSettings extends ParentFilterSettings<DashboardFilterSelectOption, string[]> {
  filterByKey: string;

  constructor(args: ParentFilterSettingsInterface & { filterByKey: string }) {
    super(args);
    this.filterByKey = args.filterByKey;
  }

  _getFilteredChildOptions(parentFilterValue: string[], options: DashboardFilterSelectOption[]): DashboardFilterSelectOption[] {
    return options.filter(option => parentFilterValue.includes(option[this.filterByKey]));
  }
}
